import { Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { ToastContainer } from 'material-react-toastify';
import 'material-react-toastify/dist/ReactToastify.css';

import ProtectedRoute from './lib/auth/ProtectedRoute';
import { ROUTES } from './lib/routes';
import ListUsers from './pages/Admin/ListUsers/ListUsers';
import SessionView from './pages/Admin/SessionView/SessionView';
import AdminSessions from './pages/Admin/Sessions/Sessions';
import UserData from './pages/Admin/UserData/UserData';
import CoachCabinet from './pages/Coach/CoachCabinet/CoachCabinet';
import CoachCalendar from './pages/Coach/CoachCalendar/CoachCalendar';
import CoachSchedule from './pages/Coach/CoachSchedule/CoachSchedule';
import Content from './pages/Content/Content';
import Home from './pages/Home/Home';
import SignIn from './pages/SignIn/Sign';
import Tariffs from './pages/Tariffs/Tariffs';

const routeConfig = [
  { path: ROUTES.HOME, component: Home, protected: true, hideSidebar: true },
  { path: ROUTES.SIGN_IN, component: SignIn, protected: false },

  // Admin routes
  { path: ROUTES.ADMIN_SESSIONS, component: AdminSessions, protected: true },
  { path: ROUTES.ADMIN_USER_DATA, component: UserData, protected: true },
  { path: ROUTES.ADMIN_USERS, component: ListUsers, protected: true },
  { path: ROUTES.ADMIN_SESSION, component: SessionView, protected: true },

  // Previewer
  { path: ROUTES.PREVIEWER, component: Content, protected: true },

  // Tariffs routes
  { path: ROUTES.TARIFFS, component: Tariffs, protected: true },

  { path: ROUTES.COACH_SCHEDULE, component: CoachSchedule, protected: true },
  { path: ROUTES.COACH_CALENDAR, component: CoachCalendar, protected: true },
  { path: ROUTES.COACH, component: CoachCabinet, protected: true },
];

function Router() {
  return (
    <BrowserRouter>
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          {routeConfig.map(
            ({ path, component: Component, protected: isProtected, hideSidebar }) => (
              <Route
                key={path}
                path={path}
                element={
                  isProtected ? (
                    <ProtectedRoute hideSidebar={hideSidebar}>
                      <Component />
                    </ProtectedRoute>
                  ) : (
                    <Component />
                  )
                }
              />
            ),
          )}
        </Routes>
      </Suspense>

      <ToastContainer position="top-right" />
    </BrowserRouter>
  );
}

export default Router;
